/**
 * @license
 * Copyright 2018 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './common_style.less'
import './state_operate.less';
import { Overlay } from 'neuroglancer/overlay';
import { Viewer, isSelectView } from 'neuroglancer/viewer';
import { registerEventListener } from 'neuroglancer/util/disposable';
import { message } from '../widget/message';
import { cancellableFetchSpecialOk } from '../util/special_protocol_request';
import { responseJson } from '../util/http_request';
import { allToolsButton, local_host_SN_flag } from 'src/main';
import throttle from 'lodash/throttle'
import i18n from '../i18n/i18n';
import { Lasso } from './lasso';

const throttleInterval = 2000;

export class StateEdit extends Overlay {
  stateList: any[];
  selectedState: any;
  stateType: string
  constructor(public viewer: Viewer, public type: string) {
    super();
    this.initDom();
    this.stateType = type;
    if (this.type === 'save') {
      this.judgeNum('status');
    } else if (this.type.includes('record')) {
      this.loadStateList(this.type);
    }

    registerEventListener(this.content.getElementsByClassName("submit_btn")[0], 'click', throttle(() => {
      this.stateOperate()
    }, throttleInterval))

    this.content.appendChild(this.buttonClose);
    this.registerEventListener(this.buttonClose, 'click', () => {
      this.dispose();
    });
  }

  initDom() {
    console.log("this.type", this.type)
    this.content.classList.add('state_operate_dialog');
    if (this.type === 'save') {
      this.content.innerHTML += `
        <h3>${i18n.dialogSave}</h3>
        <div class="dialog_container">
          <input type="text" class="label_name" placeholder="${i18n.dialogLabel}">
        </div>
       `;
    } else if (this.type.includes('record')) {
      this.content.classList.add('more_width');
      this.content.innerHTML += `
        <h3 style="text-align: center">${i18n[this.type]}</h3>
        <div class="dialog_container">
          <div class="row" data-id="0" style="pointer-events: none">
            <span>${i18n.record_index}</span>
            <span>${i18n.record_label}</span>
            <span>${i18n.record_time}</span>
            <span></span>
          </div>
        </div>
       `;
    }
    if(this.type === 'lasso_record') {
      this.content.innerHTML += `<div style="margin-top: 1rem; text-align: center;color: #999; font-size: 0.875rem; line-height: 1.25rem">${i18n.lasso_record_limit}</div>`
    }
    this.content.innerHTML += `
      <div class="footer">
        <button class="submit_btn async_submit_btn_loading">
          <i class="submit_btn_el-icon-loading"><svg t="1687856555440" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1917" width="14" height="14"><path d="M511.882596 287.998081h-0.361244a31.998984 31.998984 0 0 1-31.659415-31.977309v-0.361244c0-0.104761 0.115598-11.722364 0.115598-63.658399V96.000564a31.998984 31.998984 0 1 1 64.001581 0V192.001129c0 52.586273-0.111986 63.88237-0.119211 64.337537a32.002596 32.002596 0 0 1-31.977309 31.659415zM511.998194 959.99842a31.998984 31.998984 0 0 1-31.998984-31.998984v-96.379871c0-51.610915-0.111986-63.174332-0.115598-63.286318s0-0.242033 0-0.361243a31.998984 31.998984 0 0 1 63.997968-0.314283c0 0.455167 0.11921 11.711527 0.11921 64.034093v96.307622a31.998984 31.998984 0 0 1-32.002596 31.998984zM330.899406 363.021212a31.897836 31.897836 0 0 1-22.866739-9.612699c-0.075861-0.075861-8.207461-8.370021-44.931515-45.094076L195.198137 240.429485a31.998984 31.998984 0 0 1 45.256635-45.253022L308.336112 263.057803c37.182834 37.182834 45.090463 45.253022 45.41197 45.578141A31.998984 31.998984 0 0 1 330.899406 363.021212zM806.137421 838.11473a31.901448 31.901448 0 0 1-22.628318-9.374279L715.624151 760.859111c-36.724054-36.724054-45.018214-44.859267-45.097687-44.93874a31.998984 31.998984 0 0 1 44.77618-45.729864c0.32512 0.317895 8.395308 8.229136 45.578142 45.411969l67.88134 67.88134a31.998984 31.998984 0 0 1-22.624705 54.630914zM224.000113 838.11473a31.901448 31.901448 0 0 0 22.628317-9.374279l67.88134-67.88134c36.724054-36.724054 45.021826-44.859267 45.097688-44.93874a31.998984 31.998984 0 0 0-44.776181-45.729864c-0.32512 0.317895-8.395308 8.229136-45.578142 45.411969l-67.88134 67.884953a31.998984 31.998984 0 0 0 22.628318 54.627301zM255.948523 544.058589h-0.361244c-0.104761 0-11.722364-0.115598-63.658399-0.115598H95.942765a31.998984 31.998984 0 1 1 0-64.00158h95.996952c52.586273 0 63.88237 0.111986 64.337538 0.11921a31.998984 31.998984 0 0 1 31.659414 31.97731v0.361244a32.002596 32.002596 0 0 1-31.988146 31.659414zM767.939492 544.058589a32.002596 32.002596 0 0 1-31.995372-31.666639v-0.361244a31.998984 31.998984 0 0 1 31.659415-31.970085c0.455167 0 11.754876-0.11921 64.34115-0.11921h96.000564a31.998984 31.998984 0 0 1 0 64.00158H831.944685c-51.936034 0-63.553638 0.111986-63.665624 0.115598h-0.335957zM692.999446 363.0176a31.998984 31.998984 0 0 1-22.863126-54.381656c0.317895-0.32512 8.229136-8.395308 45.41197-45.578141l67.88134-67.884953A31.998984 31.998984 0 1 1 828.693489 240.429485l-67.892177 67.88134c-31.020013 31.023625-41.644196 41.759794-44.241539 44.393262l-0.697201 0.722488a31.908673 31.908673 0 0 1-22.863126 9.591025z" fill="#ffffff" p-id="1918"></path></svg></i>
          <span>${i18n.if_submit}</span>
        </button>
      </div>
    `;
  }

  stateOperate() {
    if (this.type == 'save') {
      let val = (<HTMLInputElement>this.content.getElementsByClassName("label_name")[0]).value.trim();
      if (!val) {
        new message(i18n.lassoPanelInputLabel, 'warning');
        return;
      } else if (!/^[A-Za-z0-9_\s]+$/.test(val)) {
        new message(i18n.lassoPanelPatter, 'warning');
        return;
      }
      this.saveState(val);
    } else if (this.type.includes('record')) {
      if (!this.selectedState) {
        new message(i18n.stateOperatePanelSelectStatu, 'warning');
        return;
      }
      this.loadState();
    }
  }

  async saveState(str: string) {
    const saveJson = this.viewer.state.toJSON();
    saveJson['allDataSource'] = this.viewer.allDataSource;
    saveJson['genelistFile'] = allToolsButton.genelistFile;
    saveJson['saveSelectedKeyVal'] = this.viewer.saveSelectedKeyVal;
    saveJson['isLegendOfImage'] = this.viewer.isLegendOfImage.value;
    saveJson['genelistFile'] = allToolsButton.genelistFile;
    saveJson['isBinsizeAuto'] = this.viewer.isBinsizeAuto.value;
    saveJson['color_scale'] = this.viewer.color_scale;
    saveJson['initBoundSize'] = this.viewer.initBoundSize;
    saveJson['proteinMergeColor'] = this.viewer.proteinMergeColor.value;
    const bodyParm = JSON.stringify({
      label: str,
      details: JSON.stringify(saveJson),
      projectId: allToolsButton.projectId,
      type: '1',
      num: 10
    })
    this.content.getElementsByClassName("submit_btn")[0].classList.add('submit_btn_loading')
    let res1 = await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/operate_status/record_save`, {
      method: "post",
      headers: {
        'Content-Type': 'application/json; charset=UTF-8'
      },
      body: bodyParm
    }, responseJson);
    this.content.getElementsByClassName("submit_btn")[0].classList.remove('submit_btn_loading')
    if (res1.code === 0) {
      if (StateEdit.label_num < 10) {
        StateEdit.label_num++;
      }
      new message(i18n.stateOperatePanelSuccess, 'success');
      this.dispose();
    }
  }

  async requestStateList(val: string) {
    const type = val.includes('status') ? '1' : '2';
    return await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/operate_status/record_list?projectId=${allToolsButton.projectId}&type=${type}`, {}, responseJson);
  }

  async loadStateList(val: string) {
    let _this = this;
    let dialogContainer: any = this.content.getElementsByClassName("dialog_container")[0];
    dialogContainer.onclick = function (e: any) {
      let bool = e.target.classList.contains('row');
      if (bool || e.target.parentNode.classList.contains('row')) {
        let element = bool ? e.target : e.target.parentNode;
        if (element.classList.contains('active')) {
          element.classList.remove('active');
          _this.selectedState = null;
        } else {
          let temp_dom = _this.content.querySelector(".row.active");
          if (temp_dom) {
            temp_dom.classList.remove('active');
          }
          element.classList.add('active');
          _this.selectedState = element.dataset.id;
        }
      }
    }

    let res = await this.requestStateList(val);
    // let res = data;
    if (res.code === 0) {
      StateEdit.label_num = res.data.length;
      if (res.data.length > 0) {
        this.stateList = res.data;
        let str = "";
        res.data.forEach((item: any, i: any) => {
          let time = item.createTime.split(' ');
          str += `
            <div class="row" data-id="${i + 1}">
              <span>${i + 1}</span>
              <span title="${item.label}">${item.label}</span>
              <span>${time[0].split('-').join('/')}</span>
              <span>${time[1]}</span>
            </div>
          `;
        })
        dialogContainer.innerHTML += str;
      }else{
        dialogContainer.innerHTML += i18n.nodata
      }
    } else {
      dialogContainer.innerHTML += i18n.nodata
    }
  }

  async judgeNum(value: string) {
    console.log(StateEdit.label_num);
    if (StateEdit.label_num < 0) {
      let res = await this.requestStateList(value);
      if (res.code === 0) {
        StateEdit.label_num = res.data.length;
      }
    }
    if (StateEdit.label_num === 10) {
      new message(i18n.stateOperatePanelSaveUp10, 'info');
    }
  }

  async loadState() {
    if (this.selectedState === '0') {
      window.location.reload();
    } else {
      this.content.getElementsByClassName("submit_btn")[0].classList.add('submit_btn_loading')
      if(this.stateType.includes('lasso')){
        let res = await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/operate_status/record_info?id=${this.stateList[this.selectedState - 1].id}&type=2`, {}, responseJson);
        if (res.code === 0) {
          this.dispose();
          const lassoButton = document.getElementsByClassName('lassoBtn')[0] as HTMLElement
          if (this.viewer.lassoTool) {
            this.viewer.lassoTool.loadLassoFile(res.data)
          } else {
            const lassoTool = new Lasso(this.viewer, lassoButton );
            lassoTool.loadLassoFile(res.data)
          }
        }
      }else{
        let res = await cancellableFetchSpecialOk(undefined, `${local_host_SN_flag}/operate_status/record_info?id=${this.stateList[this.selectedState - 1].id}&type=1`, {}, responseJson);
        if (res.code === 0) {
          let gene_nodeList = document.body.querySelectorAll(".selected-gene-more-dialog") as NodeList;
          gene_nodeList.forEach((item:Node)=>document.body.removeChild(item));
          this.viewer.initConfigState();
          const data = JSON.parse(res.data.detailJson);
          this.viewer.allDataSource = data.allDataSource;
          this.viewer.bin200_self_newlabel_color = data.bin200_self_newlabel_color;
          this.viewer.bin200_self_newlabel = data.self_newlabel_color;
          this.viewer.self_newlabel_color = data.self_newlabel_color;
          this.viewer.self_newlabel = data.self_newlabel;
          this.viewer.saveSelectedKeyVal = data.saveSelectedKeyVal;
          this.viewer.isLegendOfImage.value = data.isLegendOfImage;
          this.viewer.isBinsizeAuto.value = data.isBinsizeAuto;
          this.viewer.showSingleGene.value = undefined;
          this.viewer.proteinMergeColor.value = data.proteinMergeColor;
          allToolsButton.genelistFile = data.genelistFile;
          this.viewer.color_scale = data.color_scale;
          this.viewer.state.restoreState(data, false);
          this.viewer.jsonCloneObj = [];
          this.viewer.genePanelState.reset();
          // 修复勾选了单基因的状态读取时缩放比例异常的问题
          setTimeout(() => {
            this.viewer.crossSectionScale.restoreState(data.crossSectionScale);
          }, 300);
          isSelectView(true, 'layer-view');
          this.dispose();
        }
      }
      this.content.getElementsByClassName("submit_btn")[0].classList.remove('submit_btn_loading')
    }
  }

  static label_num: number = -1;
}
